import React, { useEffect, useState } from "react";
import "./ResidentNotices.css";

export default function ResidentNotices() {
  const [notices, setNotices] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const API = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(`${API}/api/auth/notices`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("residentToken")}`,
          },
        });

        if (!res.ok) {
          setError("Failed to load notices");
          return;
        }

        const data = await res.json();
        setNotices(data);
      } catch (err) {
        setError("Server error while loading notices");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [API]);

  return (
    <div className="resident-layout">
      
      <div className="resident-content">
        <h1 className="resident-notices-title">Notices</h1>

        {loading && <p className="resident-notices-empty">Loading...</p>}
        {error && <p className="resident-notices-error">{error}</p>}

        {!loading && !error && notices.length === 0 && (
          <p className="resident-notices-empty">No notices for your tower yet.</p>
        )}

        <div className="resident-notices-list">
          {notices.map((n) => (
            <div className="notice-item" key={n.id}>
              <div className="notice-item-title">{n.title}</div>
              <div className="notice-item-message">{n.message}</div>
              <div className="notice-item-date">
                {new Date(n.createdAt).toLocaleString()}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}